export enum I18nLabel {
    Close_Tab = "Close",
    Close_Tabset = "Close tab set",
    Active_Tabset = "Active tab set",
    Move_Tabset = "Move tab set",
    Move_Tabs = "Move tabs(?)",
    Maximize = "Maximize tab set",
    Restore = "Restore tab set",
    Fold_Tabset = "Collapse tab set",
    Unfold_Tabset = "Expand tab set",
    Popout_Tab = "Popout selected tab",
    Overflow_Menu_Tooltip = "Hidden tabs",
    Error_rendering_component = "Error rendering component",
    Error_rendering_component_retry = "Retry",
}
